import { render, staticRenderFns } from "./videolikes-censored.vue?vue&type=template&id=1f72f008"
import script from "./videolikes-censored.vue?vue&type=script&lang=js"
export * from "./videolikes-censored.vue?vue&type=script&lang=js"
import style0 from "./videolikes-censored.vue?vue&type=style&index=0&id=1f72f008&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports